import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-avator',
  templateUrl: './user-avator.component.html',
  styleUrls: ['./user-avator.component.scss']
})
export class UserAvatorComponent implements OnInit {

  @Input() firstName: string;
  @Input() lastName: string;
  @Input() fullName: string;
  @Input() userImageMediaPath: string;

  @Input() size: number = 40;

  initials: string;
  fullImageUrl: string;

  constructor() { }

  ngOnInit(): void {
  }

  setupUserInitials() {
    //const user = this.dwSecurityUserService.securityContext.ApplicationUser;
    
    // const initials = this.firstName?.charAt(0).toUpperCase() + user?.LastName?.charAt(0).toUpperCase();

    // this.initials = initials;
  }
}
